import { useMemo } from "react"
import { useGetSingleFinancialModelSettingsV2Query } from "@/feature/financial-model/api"

import { getCapitalStructureCompletitionStatus } from "../utils"

export const useCapitalStructureStatus = (financial_model_id: string) => {
  const {
    data: capitalStructureSetupSettings,
    isLoading: isLoadingSetupSettings,
  } = useGetSingleFinancialModelSettingsV2Query({
    id: financial_model_id,
    module: `capital_structure`,
    section: `setup`,
  })

  const isEquitySetupCompleted = useMemo(
    () =>
      !isLoadingSetupSettings &&
      getCapitalStructureCompletitionStatus(
        `equity`,
        capitalStructureSetupSettings?.capital_structure.settings!
      ) === `done`,
    [capitalStructureSetupSettings, isLoadingSetupSettings]
  )

  const isDebtSetupCompleted = useMemo(
    () =>
      !isLoadingSetupSettings &&
      getCapitalStructureCompletitionStatus(
        `debt`,
        capitalStructureSetupSettings?.capital_structure.settings!
      ) === `done`,
    [capitalStructureSetupSettings, isLoadingSetupSettings]
  )

  const isGrantSetupCompleted = useMemo(
    () =>
      !isLoadingSetupSettings &&
      getCapitalStructureCompletitionStatus(
        `grant`,
        capitalStructureSetupSettings?.capital_structure.settings!
      ) === `done`,
    [capitalStructureSetupSettings, isLoadingSetupSettings]
  )

  const isConvertibleNotesSetupCompleted = useMemo(
    () =>
      !isLoadingSetupSettings &&
      getCapitalStructureCompletitionStatus(
        `convertible_notes`,
        capitalStructureSetupSettings?.capital_structure.settings!
      ) === `done`,
    [capitalStructureSetupSettings, isLoadingSetupSettings]
  )

  return {
    isLoading: isLoadingSetupSettings,
    isEquitySetupCompleted,
    isDebtSetupCompleted,
    isGrantSetupCompleted,
    isConvertibleNotesSetupCompleted,
    capitalStructureSetupSettings,
  }
}
